import * as yup from "yup";
import { isRequired } from "./messages";

export const LoginSchema = yup.object().shape({
	username: yup
		.string()
		.required(isRequired("Email"))
		.email("Please enter a valid email address (e.g., name@example.com)"),
	password: yup.string().required(isRequired("Password"))
});
